import React, { Component } from 'react';

import { matchPath } from 'react-router';
import { withRouter } from 'react-router-dom';
import "./css/materialize.css";
import "./css/style.css";
import "./css/circular-progress.css";
import QRQinectAPI from '../QRQinectAPI';

class CustomizeExperience extends Component {
    constructor(props) {
        super(props);

        this.state = props.state || props.location.state || {};
        this.state.error = false;
        this.state.loading = false;
        this.state.token = props.token;
        this.state.qrGUID = props.qrGUID;
        this.state.success = false;

        this.state.apiParameters = {
            // Video upload
            file: {},
            QRCodeGUID: props.state.QRCode.GUID,
            Name: "",
            // Screen Settings
            Background: {},
            TextColor: "",
            BackgroundColor: props.backgroundColor,
            ButtonColor: props.buttonColor,
            ButtonTextColor: props.buttonTextColor,
            // CustomHTML settings
            AddProtocols: true,
            ShowButtonIcon: true,
            CallToActionProtocol: "",
            Logo: {},
            CallToActionType: "none",
            CallToActionURI: "",
            CallToActionText: "",
            CallToActionIcon: "",
            EmbeddedYoutubeID: "",
            RatingForm: false,
            FaceBook: "",
            Twitter: "",
            LinkedIn: "",
            Instagram: "",
            Email: "",
            Pinterest: "",
            Website: "",
            Youtube: "",
            Referral: false,
            FacebookLikeURL: "",
        }
    }
    componentDidMount() {
        let scannedQRCode = matchPath(window.location.pathname, {
            path: '/scan/:id/customizeExperience/:token',
            exact: false
        });
        let buyerToken = scannedQRCode ? scannedQRCode.params.token : null;
        let qrGUID = scannedQRCode ? scannedQRCode.params.id : null;
        let buyerEmail = null;
        let buyerError = false;
        // TODO: call api, pass in the token (instead of email) and verify the buyer.
        QRQinectAPI.allowAddVideoToQRCode(buyerToken, qrGUID)
            .then((response) => {
                buyerEmail = response.data;
            })
            .catch((error) => {
                console.log("error");
                console.log(error);
                buyerError = true;
            })
            .finally(() => {
                if (this.state.Buyer.Email !== buyerEmail) {
                    // we have a problem here...
                    buyerError = true;
                }
                this.setState({ buyerError: buyerError });
            });
    }

    updateAPIStateValue(object, newValue) {
        let stateCopy = Object.assign({}, this.state);
        stateCopy['apiParameters'][object] = newValue;
        this.setState(stateCopy);
    }
    handleDataChange = (event) => {
        let fieldName = event.target.getAttribute('data-fieldname');
        this.updateAPIStateValue(fieldName, event.target.value);
        switch (fieldName) {
            case "CallToActionType":
                switch (event.target.value) {
                    case "referral":
                        this.updateAPIStateValue("CallToActionIcon", "");
                        this.updateAPIStateValue("CallToActionProtocol", "");
                        this.updateAPIStateValue("CallToActionURI", "");
                        this.updateAPIStateValue("Referral", true);
                        break;
                    case "call":
                        this.updateAPIStateValue("CallToActionIcon", "fa fa-phone");
                        this.updateAPIStateValue("CallToActionProtocol", "tel:");
                        this.updateAPIStateValue("Referral", false);
                        break;
                    case "sms":
                        this.updateAPIStateValue("CallToActionIcon", "fa fa-comment");
                        this.updateAPIStateValue("CallToActionProtocol", "sms:");
                        this.updateAPIStateValue("Referral", false);
                        break;
                    case "email":
                        this.updateAPIStateValue("CallToActionIcon", "fa fa-envelope");
                        this.updateAPIStateValue("CallToActionProtocol", "mailto:");
                        this.updateAPIStateValue("Referral", false);
                        break;
                    case "website":
                        this.updateAPIStateValue("CallToActionIcon", "");
                        this.updateAPIStateValue("CallToActionProtocol", "https://");
                        this.updateAPIStateValue("Referral", false);
                        break;
                    case "review":
                        this.updateAPIStateValue("CallToActionIcon", "");
                        this.updateAPIStateValue("CallToActionProtocol", "https://");
                        this.updateAPIStateValue("Referral", false);
                        break;
                    case "fblike":
                        this.updateAPIStateValue("CallToActionIcon", "fa fa-thumbs-up");
                        this.updateAPIStateValue("CallToActionProtocol", "https://");
                        this.updateAPIStateValue("Referral", false);
                        break;
                    default:
                        this.updateAPIStateValue("CallToActionIcon", "");
                        this.updateAPIStateValue("CallToActionProtocol", "");
                        this.updateAPIStateValue("CallToActionURI", "");
                        this.updateAPIStateValue("Referral", false);
                        break;
                }
                break;
            default:
                break;
        }
    }
    handleCheckboxChange = (event) => {
        this.updateAPIStateValue([event.target.getAttribute('data-fieldname')], event.target.checked);
    }
    fileChangedHandler = (event) => {
        this.updateAPIStateValue([event.target.getAttribute('data-fieldname')], event.target.files[0]);
    }
    submitRequest = () => {
        // validate the form
        let errors = [];
        if (!this.state.apiParameters.BackgroundColor) {
            errors.push("Please select a Background color");
        }
        // if (this.state.apiParameters.CallToActionType !== "none") {
            if (this.state.apiParameters.ButtonColor === "") {
                errors.push("Please select a Button Color");
            }
            if (this.state.apiParameters.ButtonTextColor === "") {
                errors.push("Please select a Button Text Color");
            }
        // }
        this.setState({ errors: errors });
        if (errors.length) {
            this.setState({ error: true });
            return;
        }
        this.setState({ loading: true });
        QRQinectAPI.assignCustomHTMLToQRCode(this.state.apiParameters)
            .then((response) => {
                this.setState({ success: true });
            })
            .catch((error) => {
                let errorMessage = error.toString();
                if (error.response && error.response.data) {
                    errorMessage = error.response.data;
                }
                this.setState({ error: true, errors: [errorMessage] });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }
    cancelHandler = () => {
        this.props.history.push('/report/' + this.state.token);
    }
    cancelLogoHandler = () => {
        this.updateAPIStateValue("Logo", {});
    }
    cancelBackgroundHandler = () => {
        this.updateAPIStateValue("Background", {});
    }

    renderIconOptions = () => {
        return (
            <React.Fragment>
                <option value="" >Select an icon</option>
                <option value="fa fa-phone" >&#xf095; fa-phone</option>
                <option value="fa fa-mobile" >&#xf10b; mobile</option>
                <option value="fa fa-envelope" >&#xf0e0; envelope</option>
            </React.Fragment>
        );
    }
    renderButtonOptions = (ctaType) => {
        return (
            <React.Fragment>
                <div className="input-field">
                    <label htmlFor="ButtonColor">Button Color</label>
                    <input style={{ width: '50px' }} id="" type="color" data-fieldname="ButtonColor" value={this.state.apiParameters.ButtonColor} className="form-control" onChange={this.handleDataChange} />
                    <input style={{ width: 'calc(100% - 60px)', paddingLeft: '10px' }} id="ButtonColor" type="text" data-fieldname="ButtonColor" value={this.state.apiParameters.ButtonColor} className="form-control" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="ButtonTextColor">Button Text Color</label>
                    <input style={{ width: '50px' }} id="" type="color" data-fieldname="ButtonTextColor" value={this.state.apiParameters.ButtonTextColor} className="form-control" onChange={this.handleDataChange} />
                    <input style={{ width: 'calc(100% - 60px)', paddingLeft: '10px' }} id="ButtonTextColor" type="text" data-fieldname="ButtonTextColor" value={this.state.apiParameters.ButtonTextColor} className="form-control" onChange={this.handleDataChange} />
                </div>
                {this.renderButtonTextInput(ctaType)}
                {this.renderURIButton(ctaType)}
                <div style={{ textAlign: 'center' }}>Sample Button</div>
                {/* <div className="checkbox_square">
                    <input type="checkbox" id="checkbox" checked={this.state.apiParameters.ShowButtonIcon} data-fieldname="ShowButtonIcon" onChange={this.handleCheckboxChange} />
                    <label htmlFor="checkbox"><span style={{ fontSize: '12px', lineHeight: '1' }}>Show button icon?</span></label>
                </div> */}
                <div>
                    <a target="_blank" href={this.state.apiParameters.CallToActionURI} style={{ color: this.state.apiParameters.ButtonTextColor, backgroundColor: this.state.apiParameters.ButtonColor }} className="button"><i className={this.state.apiParameters.ShowButtonIcon ? this.state.apiParameters.CallToActionIcon : ''}></i> {this.state.apiParameters.CallToActionText}</a>
                </div>
            </React.Fragment>
        );
    }
    renderButtonTextInput = (ctaType) => {
        if (ctaType === "referral" || ctaType === "none") {
            return null;
        }
        return (
            <React.Fragment>
                <div className="input-field">
                    <label htmlFor="CallToActionText">Button Text</label>
                    <input id="CallToActionText" type="text" data-fieldname="CallToActionText" className="form-control" onChange={this.handleDataChange} />
                </div>
            </React.Fragment>
        );
    }
    renderURIButton = (label) => {
        if (label === "referral" || label === "none") {
            return null;
        }
        return (
            <React.Fragment>
                <div className="input-field">
                    <label htmlFor="CallToActionURI">{label}</label>
                    <input id="CallToActionURI" value={this.state.apiParameters.CallToActionURI} data-fieldname="CallToActionURI" onChange={this.handleDataChange} />
                </div>
            </React.Fragment>
        );
    }
    renderSocialMediaLinkOptions = () => {
        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>Social Media Links</div>
                <div className="input-field">
                    <label htmlFor="FaceBook">Facebook</label>
                    <input id="FaceBook" value={this.state.apiParameters.FaceBook} data-fieldname="FaceBook" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="Twitter">Twitter</label>
                    <input id="Twitter" value={this.state.apiParameters.Twitter} data-fieldname="Twitter" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="LinkedIn">LinkedIn</label>
                    <input id="LinkedIn" value={this.state.apiParameters.LinkedIn} data-fieldname="LinkedIn" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="Instagram">Instagram</label>
                    <input id="Instagram" value={this.state.apiParameters.Instagram} data-fieldname="Instagram" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="Youtube">Youtube</label>
                    <input id="Youtube" value={this.state.apiParameters.Youtube} data-fieldname="Youtube" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="Pinterest">Pinterest</label>
                    <input id="Pinterest" value={this.state.apiParameters.Pinterest} data-fieldname="Pinterest" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="Website">Website / URL</label>
                    <input id="Website" value={this.state.apiParameters.Website} data-fieldname="Website" onChange={this.handleDataChange} />
                </div>
                <div className="input-field">
                    <label htmlFor="Email">Email</label>
                    <input type="email" id="Email" value={this.state.apiParameters.Email} data-fieldname="Email" onChange={this.handleDataChange} />
                </div>
            </React.Fragment>
        );
    }
    renderCallToActionOptions = () => {
        switch (this.state.apiParameters.CallToActionType) {
            case "referral":
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("referral")}
                    </React.Fragment>
                );
            case "call":
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("Phone Number (Ex. 5555555555)")}
                    </React.Fragment>
                );
            case "sms":
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("Phone Number (Ex. 5555555555)")}
                    </React.Fragment>
                );
            case "email":
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("Email Address")}
                    </React.Fragment>
                );
            case "website":
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("Web Address")}
                    </React.Fragment>
                );
            case "review":
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("Review Link")}
                    </React.Fragment>
                );
            case "fblike":
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("Like URL")}
                    </React.Fragment>
                );
            default:
                return (
                    <React.Fragment>
                        {this.renderButtonOptions("none")}
                    </React.Fragment>
                );
        }
    }
    renderLogoUpload = () => {
        if (this.state.apiParameters.Logo.name) {
            return (
                <React.Fragment>
                    <div style={{ width: "100%", height: "200px", background: "center/contain no-repeat url(" + URL.createObjectURL(this.state.apiParameters.Logo) + ")" }}></div>
                    <a className="button" onClick={this.cancelLogoHandler} style={{ display: 'inline-block', /*width: '45%', marginRight: '10%',*/ backgroundColor: '#666' }}>REMOVE LOGO</a>
                </React.Fragment>
            );
        } else {
            return (
                <div className="input-field">
                    {/* <label htmlFor="Logo">Logo</label>
                <input id="Logo" type="file" data-fieldname="Logo" className="form-control" onChange={this.fileChangedHandler} /> */}

                    <div style={{ position: 'relative' }}>
                        <input data-fieldname="Logo" className='button' type="file" accept="image/*" onChange={this.fileChangedHandler} style={{ width: '100%', position: 'relative', opacity: '0', zIndex: '2', marginTop: '0px' }} />
                        <div className='button' style={{ position: 'absolute', top: '0px', left: '0px', zIndex: '1', marginTop: '0px' }}>CHOOSE A LOGO</div>
                    </div>
                </div>
            );
        }
    }
    renderBackgroundImageHeader = () => {
        return (
            <React.Fragment>
                <p>The Background Image or Background Color (if no image is chosen) will display around your video</p>
            </React.Fragment>
        );
    }
    renderBackgroundUpload = () => {
        if (this.state.apiParameters.Background.name) {
            return (
                <React.Fragment>
                    <div style={{ width: "100%", height: "200px", background: "center/contain no-repeat url(" + URL.createObjectURL(this.state.apiParameters.Background) + ")" }}></div>
                    <a className="button" onClick={this.cancelBackgroundHandler} style={{ display: 'inline-block', /*width: '45%', marginRight: '10%',*/ backgroundColor: '#666' }}>REMOVE BACKGROUND IMAGE</a>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div>The background image or color will be placed around your video as an accent.</div>
                    <div>1900x1100 pixel background size recommended.</div>
                    <div className="input-field">
                        <div style={{ position: 'relative' }}>
                            <input data-fieldname="Background" className='button' type="file" accept="image/*" onChange={this.fileChangedHandler} style={{ width: '100%', position: 'relative', opacity: '0', zIndex: '2', marginTop: '0px' }} />
                            <div className='button' style={{ position: 'absolute', top: '0px', left: '0px', zIndex: '1', marginTop: '0px' }}>CHOOSE A BACKGROUND IMAGE</div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }
    renderCallToActionSection = () => {
        if (true) {
            return (
                <React.Fragment>
                    <div style={{ textAlign: 'center' }}>Call to Action</div>
                    <div className="input-field">
                        <label htmlFor="CallToActionType">Call To Action Type (Select One)</label>
                        <select style={{ display: 'block', backgroundColor: 'transparent', border: '0' }} data-fieldname="CallToActionType" onChange={this.handleDataChange}>
                            <option value="none">None</option>
                            <option value="referral">Referral</option>
                            <option value="call">Call</option>
                            <option value="sms">SMS</option>
                            <option value="email">Email</option>
                            <option value="website">Website / URL</option>
                            <option value="review">Leave a Review</option>
                            <option value="fblike">Facebook Like</option>
                        </select>
                    </div>
                    {this.renderCallToActionOptions()}
                </React.Fragment>
            );
        }
    }
    renderExample = () => {
        return (
            <div style={{ textAlign: 'center' }}>
                <a onClick={() => { this.setState({ showExample: true }) }} style={{ display: 'inline-block', width: '45%' }}>SHOW EXAMPLE</a>
            </div>
        );
    }
    renderHeader = () => {
        if (this.state.buyerError) {
            return (
                <p>I'm sorry, but it appears that you are not the owner of this Say More Code. If you feel this is an error, please try again.</p>
            );
        }
        else {
            return (
                <React.Fragment>
                    {this.renderLogoUpload()}
                    {this.renderBackgroundUpload()}
                    <div style={{ textAlign: 'center' }}> - or - </div>
                    <div className="input-field">
                        <label htmlFor="BackgroundColor">Background Color</label>
                        <input style={{ width: '50px' }} id="" type="color" data-fieldname="BackgroundColor" value={this.state.apiParameters.BackgroundColor} className="form-control" onChange={this.handleDataChange} />
                        <input style={{ width: 'calc(100% - 60px)', paddingLeft: '10px' }} id="BackgroundColor" type="text" data-fieldname="BackgroundColor" value={this.state.apiParameters.BackgroundColor} className="form-control" onChange={this.handleDataChange} />
                    </div>
                    {this.renderCallToActionSection()}

                    {this.renderSocialMediaLinkOptions()}
                    {/* <div className="input-field">
                        <label htmlFor="CallToActionIcon">Button Icon (view available icons <a target="_blank" href="https://fontawesome.com/v4.7.0/icons/">here</a>)</label>
                        <select style={{ fontFamily: "FontAwesome", display: 'block', paddingLeft: '5px' }} data-fieldname="CallToActionIcon" onChange={this.handleDataChange}>
                            {this.renderIconOptions()}
                        </select>
                    </div> */}

                </React.Fragment>
            );
        }
    }
    renderHeaderText() {
        if (this.state.buyerError) {
            return (
                <p>I'm sorry, but it appears that you are not the owner of this Say More Code. If you feel this is an error, please try again.</p>
            );
        }
        return null;
    }
    renderBody() {
        if (this.state.loading || this.state.success || this.state.buyerError) {
            return null;
        } else {
            return (
                <div>
                    {/* <video src={URL.createObjectURL(this.state.selectedFile)} style={{width: '100%'}} /> */}
                    <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', width: '45%', marginRight: '10%', backgroundColor: '#666' }}>CANCEL</a>
                    <a className="button" onClick={this.submitRequest} style={{ display: 'inline-block', width: '45%' }}>CONTINUE</a>
                </div>
            );
        }
    }
    getHeadStyle() {
        if (this.state.smallscreen) {
            return { marginBottom: '0px' };
        } else {
            return null;
        }
    }
    renderLoadingModal = () => {
        if (this.state.loading) {
            return (
                <React.Fragment>
                    <div onClick={() => { this.setState({ error: false }) }} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px', zIndex: '1' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', zIndex: '1' }}>
                        <div>
                            Sending...
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderExampleModal = () => {
        if (this.state.showExample) {
            return (
                <React.Fragment>
                    <div onClick={() => { this.setState({ showExample: false }) }} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px', zIndex: '1' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '0px', zIndex: '1' }}>
                        <img style={{ width: "100%", height: "100%" }} src="https://qrqinect.s3.amazonaws.com/client/1/media/images/ExampleWebEx.png" alt="Web Experience Sample" />
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderErrorModal = () => {
        if (this.state.error) {
            return (
                <React.Fragment>
                    <div onClick={() => { this.setState({ error: false }) }} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px', zIndex: '1' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', zIndex: '1' }}>
                        <div style={{ color: 'red' }}>
                            {this.state.errors.map((error, idx) => (
                                <div key={idx}>{error}</div>
                            ))}
                        </div>
                        <div>
                            <a className="button" onClick={() => { this.setState({ error: false }) }} style={{ display: 'inline-block', backgroundColor: '#666' }}>CLOSE</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderSuccessModal = () => {
        if (this.state.success) {
            return (
                <React.Fragment>
                    <div style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px', zIndex: '1' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', zIndex: '1' }}>
                        <div>
                            Your web experience has been successfully customized.
                        </div>
                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block' }}>MY ACCOUNT</a>
                        </div>
                        <div>
                            <a className="button" onClick={() => { this.props.history.push('/scan/' + this.state.qrGUID + '/view'); }} style={{ display: 'inline-block' }}>PREVIEW EXPERIENCE</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head" style={this.getHeadStyle()}>
                                <div className="logoImage"></div>
                                <div style={{ textAlign: 'center' }}>
                                    Web Experience Customization
                                </div>
                                {this.renderExample()}
                                {this.renderHeader()}
                            </div>
                            {this.renderBody()}
                            {this.renderExampleModal()}
                            {this.renderErrorModal()}
                            {this.renderLoadingModal()}
                            {this.renderSuccessModal()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(CustomizeExperience);



// WEBPACK FOOTER //
// ./src/components/CustomizeExperience.js